// @ts-ignore
import { PathLayer } from '@deck.gl/layers';
import { getCurrGeoLevelName, getDeckStrokeColor, getDeckStrokeWeight, getPathData } from '../../helpers/utils';

export const DeckPathLayer = ({
    geoJSON,
    selectedGeo,
    selectedTab,
    isChecked,
    catchment,
}: {
    geoJSON: any;
    selectedGeo: any;
    selectedTab: number;
    isChecked: any;
    catchment: string | null;
}) => {
    if (!geoJSON?.features) return null;

    return new PathLayer({
        id: 'path-layer',
        data: getPathData(geoJSON, selectedGeo, catchment),
        getPath: (d: any) => d.coordinates.map((coord: number[]) => [coord[0], coord[1]]),
        getColor: (d: any) => {
            // Handle both old structure (geoLevel) and new structure (geoValue)
            const geoLevel = d.properties.geoValue || d.properties.geoLevel;
            return getDeckStrokeColor(selectedGeo, geoLevel, d.properties.is_adjacent, catchment, isChecked?.subregionBoundaries);
        },
        getWidth: (d: any) => isChecked?.adjacency && !d.properties.is_adjacent ? 2.5 : 1.5,
        widthUnits: 'pixels',
        pickable: false,
        updateTriggers: {
            getColor: [selectedGeo, isChecked?.adjacency, catchment, isChecked?.subregionBoundaries],
            getWidth: [isChecked?.adjacency],
        },
    });
};